  import { put, call } from "redux-saga/effects";
  import {ActionConstants, ApiConstants} from "../constants";
  import axios from "axios";

  export default function* getStatesSaga(data) {
    try {

      const result = yield call(getStatesApi, data.payload);

      if (result == null || result.status !== 1) {
        yield put({
          type: ActionConstants.GET_STATES_FAILURE,
          payload: {
            result: result != null ? result.error : null,
          },
        });
      } else {
        yield put({
          type: ActionConstants.GET_STATES_SUCCESS,
          payload: {
            result: result.data,
          },
        });
      }
    } catch (e) {
      yield put({
        type: ActionConstants.GET_STATES_FAILURE,
        payload: {
          result: e,
        },
      });
    }
  }

  const getStatesApi = params => {
    const url = ApiConstants.URI_FE + ApiConstants.API_GET_STATES;
    return axios.get(url, { params: params }).then(response => response.data);
  };
